<template>
  <div
    role="dialog"
    class="modal modal-drawer-list-scroll fade fixed-end"
    aria-modal="true"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-11 dw-md-8 dw-lg-6 dw-xl-4"
    >
      <validation-observer
        tag="div"
        class="modal-content"
        @submit.native.prevent
        ref="validation"
      >
        <div class="modal-header">
          <h2 class="modal-title">Add Screen</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="btn-close"
          ></button>
        </div>

        <div class="modal-body pt-0 pb-0 flex-grow-1">
          <div class="mt-3 mb-3">
            <validation-provider name="name" vid="name" rules="required">
              <label class="form-label">Name</label>
              <c-input type="text" v-model="name" />
              <c-help-block />
            </validation-provider>
          </div>

          <div class="mb-3">
            <validation-provider name="address" vid="address" rules="required">
              <label class="form-label">Address</label>
              <c-input type="text" v-model="address" />
              <c-help-block />
            </validation-provider>
          </div>

          <div class="mb-3">
            <label class="form-label">Location</label>
            <c-input type="text" v-model="location" placeholder="-123.123, 456.456" />
            <small class="text-muted mt-2 d-block">
              Enter Latitude and Longitude (e.g. -123.123, 456.456)
            </small>
            <p v-if="locationError" class="text-danger small mb-0">{{ locationError }}</p>
          </div>

          <div class="mb-3">
            <validation-provider name="media owners" vid="media_owner_ids">
              <label class="form-label">Media Owners</label>
              <media-owner-select v-model="mediaOwnerIds" :multiple="true" />
              <c-help-block />
            </validation-provider>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" data-bs-dismiss="modal" class="btn btn-outline-info">
            Close
          </button>
          <c-button
            type="button"
            class="btn btn-primary"
            :disabled="saving"
            @click="handleSave"
          >
            <span v-if="saving">
              <i class="far fa-spinner-third fa-spin me-1"></i>
              Saving...
            </span>
            <span v-else>
              Add Screen
            </span>
          </c-button>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { toast, CModal } from '@chameleon/chameleon-vue'
import { helperMethods } from '@/vuex/modules/screens'
import MediaOwnerSelect from '@/components/media-owners/MediaOwnerSelect'

export default {
  name: 'AddScreen',
  extends: CModal,

  components: {
    MediaOwnerSelect
  },

  data () {
    return {
      name: '',
      address: '',
      location: '',
      mediaOwnerIds: [],
      saving: false,
      locationError: null
    }
  },

  async mounted () {
    this.addEventListener('open', () => {
      this.resetForm()
    })

    this.addEventListener('close', () => {
      this.resetForm()
    })
  },

  methods: {
    ...helperMethods,

    resetForm () {
      this.name = ''
      this.address = ''
      this.location = ''
      this.mediaOwnerIds = []
      this.locationError = null
      this.saving = false
      if (this.$refs.validation) {
        this.$refs.validation.reset()
      }
    },

    parseLocation () {
      this.locationError = null

      if (!this.location) {
        return { latitude: null, longitude: null }
      }

      const parts = this.location
        .split(',')
        .map(part => part.trim())
        .filter(Boolean)

      if (parts.length !== 2) {
        this.locationError = 'Enter latitude and longitude separated by a comma.'
        return null
      }

      const [latitude, longitude] = parts.map(Number)

      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        this.locationError = 'Latitude and longitude must be numbers.'
        return null
      }

      return { latitude, longitude }
    },

    async handleSave () {
      const isValid = await this.$refs.validation.validate()

      if (!isValid) {
        return
      }

      const parsedLocation = this.parseLocation()

      if (!parsedLocation) {
        return
      }

      this.saving = true

      try {
        const screen = await this.storeScreen({
          name: this.name,
          address: this.address,
          latitude: parsedLocation.latitude,
          longitude: parsedLocation.longitude,
          media_owner_ids: this.mediaOwnerIds,
          is_manual: true
        })

        toast('Screen added successfully', 'success')
        this.$emit('saved', screen)
        this.close()
        this.resetForm()
      } catch (error) {
        toast('Unable to add screen', 'danger')
        throw error
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
